module.exports = __webpack_public_path__ + "img/chevron-double-right.cca1400c.svg";